module.exports = "/_next/static/videos/buyer-3-f4e5ad328238bc5c885fbbc5c16a8ff9.mp4";